import React from 'react';
import Article from '@gik/blog/models/Article';
import ArticleLinkCardList from '@gik/blog/components/ArticleLinkCardList';
import { ArticleLinkCardStyle } from '@gik/blog/components/ArticleLinkCard';
import { LoadingSpinner } from '@gik/ui';
import RedisClient from '../../../utils/RedisClient';
import WordpressPost from '@gik/core/models/wordpress/WordpressPost';
import WordpressConverter from '@gik/blog/utils/WordpressConverter';
import WordpressSearchResult from '@gik/core/models/wordpress/WordpressSearchResult';
import getPreviewMode from '@gik/core/utils/PreviewMode';

interface SingleRowArticleSearchResultsProps {
  searchQuery: string;
  userId: string;
}

export default function SingleRowArticleSearchResults(props: SingleRowArticleSearchResultsProps) {
  return <_SingleRowArticleSearchResults {...props} />;
}

// TODO: convert below to a functional component

interface SingleRowArticleSearchResultsState {
  articles: Article[];
  resultsCount: number;
  loading: boolean;
}

class _SingleRowArticleSearchResults extends React.Component<
  SingleRowArticleSearchResultsProps,
  SingleRowArticleSearchResultsState
> {
  constructor(props: SingleRowArticleSearchResultsProps) {
    super(props);
    this.state = {
      articles: [],
      resultsCount: 0,
      loading: true,
    };
    this._fetch();
  }

  render() {
    const showAllLink = `/search/article?search=${encodeURIComponent(this.props.searchQuery)}`;
    return (
      <div className="blog search article-search-results single-row">
        {!this.state.loading ? (
          <div className="bs-padding-wrapper">
            <div className="bs-padding">
              <div className="single-row-padding">
                <a href={showAllLink}>
                  <p className="results-count">{this.state.resultsCount + ' ARTICLES & RECIPES'}</p>
                </a>
                {this.state.articles.length > 0 ? (
                  <div className="single-row-content">
                    <ArticleLinkCardList articleLinks={this.state.articles} style={ArticleLinkCardStyle.small} />
                    {this.state.resultsCount > 3 ? (
                      <a className="show-all" href={showAllLink}>
                        <h3 className="upper">
                          See all <br /> &amp; Refine
                        </h3>
                      </a>
                    ) : null}
                  </div>
                ) : (
                  <p>No Articles Found</p>
                )}
              </div>
            </div>
          </div>
        ) : (
          <LoadingSpinner center />
        )}
      </div>
    );
  }

  private async _fetch() {
    const postsCountSearchResponse = await RedisClient.searchForPosts(this.props.searchQuery);
    const resultsCount = Object.values(postsCountSearchResponse.data).length;
    let articles: Article[] = [];
    if (resultsCount > 0) {
      const postSearchResults = Object.values(postsCountSearchResponse.data) as WordpressSearchResult[];
      const fullPostsResponse = await RedisClient.getPostsByIds(
        postSearchResults.slice(0, 3).map(result => result.id.toString())
      );
      articles = fullPostsResponse.data
        .map((post: WordpressPost) => WordpressConverter.convertPost(post))
        .filter(article => !article.isPreviewOnly || article.isPreviewOnly === getPreviewMode());
    }

    this.setState({
      articles,
      resultsCount,
      loading: false,
    });
  }
}
